import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button';
import InlineNotice from '../../components/InlineNotice';
import Input from '../../components/Input';
import PageHeader from '../../components/PageHeader';
import PasswordInput from '../../components/PasswordInput';
import AppConfig from '../../config';
import { getDeviceInfo } from '../../hooks/useDeviceInfo';
import { t } from '../../lang';
import RequestService from '../../services/RequestService';
import { authSlice } from '../../store/slices';
import './RecoveryPin.scss';

const { routes } = AppConfig;
const PASSWORD_MAX_LENGTH = 64;

const RecoveryPin = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const intl = useIntl();
	const initDataTG = useSelector(state => state.app.initDataTG);
	const username = useSelector(state => state.auth.username);
	const password = useSelector(state => state.auth.password);

	const [withdrawalBlockMin, setWithdrawalBlockMin] = useState();

	const onContinue = async () => {
		const deviceInfo = await getDeviceInfo();
		const { fingerprintId } = deviceInfo;
		const res = await RequestService.ResetPinCode(username, password, initDataTG, fingerprintId);

		res?.Status === 'Success' && navigate({ pathname: routes.createPin }, { state: { flow: 'recoverPin' } });
	};

	const updateUsername = e => {
		dispatch(authSlice.actions.setUsername(e.target.value));
	};

	const onBlurUsername = e => {
		const value = e.target.value.trim();
		dispatch(authSlice.actions.setUsername(value));
	};

	const updatePassword = e => {
		dispatch(authSlice.actions.setPassword(e.target.value));
	};

	const onBlurPassword = e => {
		const value = e.target.value.trim();
		dispatch(authSlice.actions.setPassword(value));
	};

	useEffect(() => {
		const getPinCooldown = async () => {
			try {
				const response = await RequestService.GetWithdrawalBlockSettings();

				setWithdrawalBlockMin(response.PinChangeWithdrawalBlockMin);
			} catch (error) {
				console.log(error);
			}
		};

		getPinCooldown();
	}, []);

	const formatMinutes = totalMinutes => {
		const hours = Math.floor(totalMinutes / 60);
		const minutes = String(totalMinutes % 60).padStart(2, '0');

		return `${hours}:${minutes}`;
	};

	return (
		<div className='RecoveryPin'>
			<PageHeader header={'PIN-code recovery'} subheader={'Enter your login and password to verify your identity'} />

			<div className='RecoveryPin-wrapper'>
				<Input
					className='SignIn__username FormBlock'
					maxLength={30}
					onChange={updateUsername}
					onBlur={onBlurUsername}
					placeholder={intl.formatMessage({ id: 'Enter your login' })}
					value={username}
				/>

				<PasswordInput
					placeholder={intl.formatMessage({ id: 'Enter your password' })}
					className='RecoveryPin-password FormBlock'
					value={password}
					onChange={updatePassword}
					onBlur={onBlurPassword}
					maxLength={PASSWORD_MAX_LENGTH}
				/>

				{withdrawalBlockMin > 0 && (
					<InlineNotice icon='EXCLAMATIONMARK_CIRCLE'>
						{t('Please note: Once the PIN-code is changed, withdrawal will be disabled for {time}.', {
							time: formatMinutes(withdrawalBlockMin),
						})}
					</InlineNotice>
				)}

				<Button className='RecoveryPin-btn-forgot' styleType='ghost' onClick={() => navigate(routes.recoveryPassword)}>
					{t('Forgot password?')}
				</Button>

				<Button
					className='RecoveryPin-btn-continue'
					styleType='primary'
					onClick={onContinue}
					disabled={password && username ? password.length < 6 : true}
				>
					{t('Continue')}
				</Button>
			</div>
		</div>
	);
};

export default RecoveryPin;
